// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OpponentVideo__container-d58069 {
  display: flex;
  align-items: stretch;
  justify-content: stretch;
  background-color: var(--addition-100);
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  --border-radius: 8px;
  border-radius: var(--border-radius);
}

.OpponentVideo__border-container-e299e9 {
  position: absolute;
  top: 0;
  inset-inline-end: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  border-radius: var(--border-radius);
}

.OpponentVideo__isSpeaking-fa0498 {
  box-shadow: 0 0 0 2px var(--addition-90) inset;
}

.OpponentVideo__withRiseHand-ec52bc {
  box-shadow: 0 0 0 2px var(--addition-130) inset;
}

.OpponentVideo__menuButton-f3eca7 {
  position: absolute;
  top: 8px;
  inset-inline-end: 8px;
  z-index: 2;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.15s ease-in-out;
}

.OpponentVideo__container-d58069:hover .OpponentVideo__menuButton-f3eca7,
.OpponentVideo__menuButtonVisible-dc0a91 {
  opacity: 1;
  pointer-events: auto;
}

.OpponentVideo__menu-cf88fd {
  min-width: 280px;
  background-color: var(--light-10-addition-120);
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/Shared/OpponentVideo/OpponentVideo.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,oBAAA;EACA,wBAAA;EACA,qCAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,oBAAA;EACA,mCAAA;AACF;;AAEA;EACE,kBAAA;EACA,MAAA;EACA,mBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,mCAAA;AACF;;AAEA;EACE,8CAAA;AACF;;AAEA;EACE,+CAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,UAAA;EACA,UAAA;EACA,oBAAA;EACA,qCAAA;AACF;;AAEA;;EAEE,UAAA;EACA,oBAAA;AACF;;AAEA;EACE,gBAAA;EACA,8CAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  align-items: stretch;\n  justify-content: stretch;\n  background-color: var(--addition-100);\n  overflow: hidden;\n  position: relative;\n  box-sizing: border-box;\n  --border-radius: 8px;\n  border-radius: var(--border-radius);\n}\n\n.border-container {\n  position: absolute;\n  top: 0;\n  inset-inline-end: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  border-radius: var(--border-radius);\n}\n\n.isSpeaking {\n  box-shadow: 0 0 0 2px var(--addition-90) inset;\n}\n\n.withRiseHand {\n  box-shadow: 0 0 0 2px var(--addition-130) inset;\n}\n\n.menuButton {\n  position: absolute;\n  top: 8px;\n  inset-inline-end: 8px;\n  z-index: 2;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.15s ease-in-out;\n}\n\n.container:hover .menuButton,\n.menuButtonVisible {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.menu {\n  min-width: 280px;\n  background-color: var(--light-10-addition-120);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `OpponentVideo__container-d58069`,
	"border-container": `OpponentVideo__border-container-e299e9`,
	"borderContainer": `OpponentVideo__border-container-e299e9`,
	"isSpeaking": `OpponentVideo__isSpeaking-fa0498`,
	"withRiseHand": `OpponentVideo__withRiseHand-ec52bc`,
	"menuButton": `OpponentVideo__menuButton-f3eca7`,
	"menuButtonVisible": `OpponentVideo__menuButtonVisible-dc0a91`,
	"menu": `OpponentVideo__menu-cf88fd`
};
module.exports = ___CSS_LOADER_EXPORT___;
